import React from "react";
import {useDarkMode} from "../../contexts/darkModeContext";

const FormDivider = ({ label, darkMode = false, className = 'py-4' }) => {
    
    return (
        <div className={`${className} sm:col-span-full relative justify-center items-center font-semibold uppercase flex`}>
            <div className="relative flex justify-start w-fit">
                <span className={`${darkMode ? 'bg-bgDark text-white' : 'bg-white text-black'} px-3 rounded-lg font-semibold italic whitespace-nowrap`}>{label}</span>
            </div>
            <div aria-hidden="true" className={`w-full border-t-2 ${darkMode ? 'border-neutral-700' : 'border-gray-300'}`}/>
        </div>
    );
};

export default FormDivider;
